export const REGISTER = 0
export const SUCCESS = 1

export const SELECTED_YES = 'YES'
export const SELECTED_NO = 'NO'
export const STATUS_UNDECIDED = 'UNDECIDED'
